<template>
  <!-- ヘッダー -->
  <header class="header header--gradation"
  :class="{
  'header--pc': !isMenuVisible,
  'header--white-back': isWhiteBack
  }">
    <!-- 左側 -->
    <div v-if="isBackProcess" class="btn btn-close btn-close--header-pc" @click="handleEnd">
      <div class="btn-close-text">{{ $t('test_list.finish') }}</div>
    </div>
    <div v-else-if="isExplanationLeft" class="btn btn-close btn-close--header-pc" @click="handleCancel">
      <div class="btn-close-text">{{isQuestion ? $t('oral_frailty.cancel_check') : $t('patk_test.stop_test')}}</div>
    </div>
    <div v-else-if="isBack" class="header-back" @click="handleBack">
      <div class="header-back-img"></div>
      {{ $t('history.back') }}
    </div>
    <div v-else class="header-space"></div>

    <!-- タイトル -->
    <div class="header-system-name-pc" :class="isPrint ? 'header-system-name-pc--font-big':''">{{isTitle}}</div>

    <!-- 右側 -->
    <div v-if="isBackProcess" class="header-space">
      <!-- 言語選択 -->
      <div class="header-language-selector" v-click-outside="closeDropdown">
        <button 
          type="button" 
          class="header-language-button" 
          @click="toggleDropdown"
          :aria-expanded="isDropdownOpen"
        >
          <img src="@/assets/img/world.png" alt="Language" class="header-language-icon" />
          <span class="header-language-text">{{ selectedLocale === 'ja' ? 'JP' : 'EN' }}</span>
        </button>
        <div v-if="isDropdownOpen" class="header-language-dropdown">
          <div 
            class="header-language-option" 
            :class="{ 'header-language-option--active': selectedLocale === 'ja' }"
            @click="selectLanguage('ja')"
          >
            JP・日本語
          </div>
          <div 
            class="header-language-option" 
            :class="{ 'header-language-option--active': selectedLocale === 'en' }"
            @click="selectLanguage('en')"
          >
            EN・English
          </div>
        </div>
      </div>
      <div class="header-menu btn" @click="handleToggleMenu"></div>
    </div>
    <div v-else-if="isExplanationRight" class="header-explanation">
      <div class="header-explanation-detail">
        <div class="explanation-timer"></div>
        <div>{{isTimer}}{{ $t('settings.seconds_suffix') }}</div>
      </div>
      <div v-if="isUseAnalaysis" class="header-explanation-detail ml-24">
        <div class="explanation-analysis" :class="isAnalysis ===true? 'explanation-analysis--on':'explanation-analysis--off'"></div>
        <div>{{isAnalysis ===true ? $t('patk_test.clarity_on') : $t('patk_test.clarity_off')}}</div>
      </div>
    </div>
    <div v-else-if="isPrint" class="header-print" @click="handlePrint">
      <div class="header-print-img"></div>
      {{ $t('report.print') }}
    </div>
    <div v-else class="header-space"></div>

    <!-- メニュー -->
    <div v-if="isMenuVisible" class="menu">
      <div class="menu-user">
        <div class="btn menu-close" @click="handleToggleMenu"></div>
        <div class="menu-user-icon"></div>
        <div class="menu-user-id">{{ operatorId }}</div>
      </div>
      <div class="menu-list">
        <div class="menu-item" @click="handleShowHistory">
          <div class="menu-item-text">{{ $t('menu.history') }}</div>
        </div>
        <div class="menu-item" @click="handleShowSetting">
          <div class="menu-item-text">{{ $t('menu.settings') }}</div>
        </div>
        <div class="menu-item menu-item--logout" @click="handleLogout">
          <div class="menu-item-text">{{ $t('menu.logout') }}</div>
        </div>
      </div>
      <div class="flex justify-content-center mt-23">
        <div id="back-measure-menu" class="btn btn-outline-accent-color" @click="handleToMeasure">{{ buttonText }}</div>
      </div>
      <div class="menu-ver">Ver1.0.0</div>
    </div>
  </header>
</template>

<script>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { ref, defineComponent, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import * as Paths from '@/components/common/paths';

export default defineComponent({
  directives: {
    'click-outside': {
      mounted(el, binding) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unmounted(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  emits: ["end","cancel","back"],
  props: {
    isWhiteBack: Boolean,
    isBackProcess: Boolean,
    isExplanationLeft: Boolean,
    isExplanationRight: Boolean,
    isQuestion: Boolean,
    isBack: Boolean,
    isPrint: Boolean,
    isTitle: String,
    isTimer: String,
    isAnalysis: Boolean,
    isUseAnalaysis: Boolean,
  },
  setup(_, { emit }) {
    const store = useStore();
    const router = useRouter();
    const { t, locale } = useI18n();

    const operatorId = ref(store.getters['dataManagement/getOperatorId']);
    const subjectId = ref(store.getters['dataManagement/getSubjectId']); //subjectIdの取得：メニュー表示判定用
    const isMeasure = ref(false);
    const isMenuVisible = ref(false);
    
    // 言語選択
    const selectedLocale = ref(locale.value);
    const isDropdownOpen = ref(false);
    
    // ドロップダウンの開閉
    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };
    
    const closeDropdown = () => {
      isDropdownOpen.value = false;
    };
    
    // 言語選択
    const selectLanguage = (newLocale) => {
      locale.value = newLocale;
      selectedLocale.value = newLocale;
      localStorage.setItem('app-locale', newLocale);
      isDropdownOpen.value = false;
      // CSSクラスも更新
      document.documentElement.setAttribute('lang', newLocale);
      const appElement = document.getElementById('app');
      if (appElement) {
        appElement.className = `lang-${newLocale}`;
      }
    };

    onMounted(() => {
      // localStorageから言語を読み込む
      const savedLocale = localStorage.getItem('app-locale');
      if (savedLocale && (savedLocale === 'ja' || savedLocale === 'en')) {
        locale.value = savedLocale;
        selectedLocale.value = savedLocale;
        document.documentElement.setAttribute('lang', savedLocale);
        const appElement = document.getElementById('app');
        if (appElement) {
          appElement.className = `lang-${savedLocale}`;
        }
      }
      
      // 現在のパスを取得
      const currentPath = router.currentRoute.value.path;
      // パスから測定中かどうかを判定
      if (currentPath.startsWith(Paths.SUBJECT_PATH) && currentPath !== Paths.SUBJECT_PATH) {
        isMeasure.value = false;
      } else {
        isMeasure.value = true;
      }
    });

    // Top検査測定終了
    const handleEnd = () => {
      emit("end");
    };

    // 検査中止
    const handleCancel = () => {
      emit("cancel");
    }

    // 結果レポート画面：戻る
    const handleBack = () => {
      emit("back");
    }

    // 結果レポート画面：印刷
    const handlePrint = () => {
      emit("print")
    }

    const buttonText = computed(() => {
      if (isMeasure.value) {
        if(!subjectId.value) {
          // 被験者IDがない場合は、被検査者画面へ遷移
          return t('menu.back_to_subject_settings');
        }
        return t('menu.back_to_measure_selection');
      } else {
        return t('menu.back_to_subject_settings');
      }
    });

    // メニューの表示切り替えを処理する関数
    const handleToggleMenu = () => {
      isMenuVisible.value = !isMenuVisible.value;
    };

    // 測定履歴画面へ遷移する関数
    const handleShowHistory = async () => {
      try {
        // 測定履歴画面へ遷移
        await router.push({
          name: 'history',
          params: { operator_id: operatorId.value },
        });
      } catch (error) {
        // エラーが発生した場合、コンソールにエラーメッセージを表示
        console.error('測定履歴画面への遷移に失敗しました:', error);
      }
    };

    // 設定画面へ遷移する関数
    const handleShowSetting = async () => {
      try {
        // 設定画面へ遷移
        await router.push({
          name: 'basicConfigGeneral',
          params: { operator_id: operatorId.value },
        });
      } catch (error) {
        // エラーが発生した場合、コンソールにエラーメッセージを表示
        console.error('設定画面への遷移に失敗しました:', error);
      }
    };

    // ログアウト処理を行う関数
    const handleLogout = async () => {
      try {
        // 被検査者情報とオペレータ情報をクリア
        await store.dispatch('dataManagement/clearSubject');
        await store.dispatch('dataManagement/clearOperator');
        await store.dispatch('dataManagement/clearAuth');

        // ログイン画面へ遷移
        await router.push({
          name: 'login',
        });
      } catch (error) {
        // エラーが発生した場合、コンソールにエラーメッセージを表示
        console.error('ログアウトに失敗しました:', error);
      }
    };

    // 測定画面へ遷移する関数
    const handleToMeasure = async () => {
      try {
        // 測定中の場合、パタカ選択画面へ遷移
        if (isMeasure.value) {
          if(!subjectId.value) {
            // 被験者IDがない場合は、被検査者画面へ遷移
            await router.push({
              name: 'subjectsRegist',
              params: { operator_id: operatorId.value },
            });
          }else{
            await router.push({
              name: 'selectMenu',
              params: { operator_id: operatorId.value },
            });
          }
        } else {
          // 測定終了中、被検査者画面へ遷移
          await router.push({
            name: 'subjectsRegist',
            params: { operator_id: operatorId.value },
          });
        }
      } catch (error) {
        // エラーが発生した場合、コンソールにエラーメッセージを表示
        console.error('測定画面への遷移に失敗しました:', error);
      }
    };

    return {
      operatorId,
      subjectId,
      buttonText,
      isMeasure,
      isMenuVisible,
      selectedLocale,
      isDropdownOpen,
      toggleDropdown,
      closeDropdown,
      selectLanguage,
      handleEnd,
      handleCancel,
      handleBack,
      handlePrint,
      handleToggleMenu,
      handleShowHistory,
      handleShowSetting,
      handleLogout,
      handleToMeasure,
    };
  },
});
</script>

<style lang="scss" scoped>
.header-language-selector {
  position: relative;
  margin-right: 12px;

  .header-language-button {
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: rgba(0, 40, 80, 0.05);
    border: none;
    border: solid 1px rgba(14, 40, 80, 0.05);
    border-radius: 8px;
    padding: 9px 10px;
    font-size: 12px;
    font-family: "NotoSans-Medium";
    color: #002850;
    cursor: pointer;
    min-width: 64px;
    justify-content: space-between;


    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
    }

    &:hover {
      opacity: 0.9;
    }

    .header-language-icon {
      width: 14px;
      height: 14px;
      flex-shrink: 0;
    }

    .header-language-text {
      flex: 1;
      text-align: center;
      font-size: 14px;
    }

    .header-language-arrow {
      font-size: 8px;
      transition: transform 0.2s;
      flex-shrink: 0;

      &.header-language-arrow--open {
        transform: rotate(180deg);
      }
    }
  }

  .header-language-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    min-width: 160px;
    overflow: hidden;
    z-index: 200;

    .header-language-option {
      padding: 8px 16px;
      font-size: 16px;
      font-family: "NotoSans-Medium";
      line-height: 1.88;
      color: #002850;
      cursor: pointer;
      transition: background-color 0.2s;

      &:hover {
        background-color: #f5f5f5;
      }

      &.header-language-option--active {
        background-color: #fff6e3;
      }
    }
  }
}

.menu-item:hover {
  cursor: pointer;
}

.btn-outline-accent-color {
  padding-top: 12px;
  padding-right: 17px;
  padding-bottom: 11px;
  padding-left: 17px;
}
</style>